import { render } from "./BodyAgro.vue?vue&type=template&id=6b7d6ae0&scoped=true"
import script from "./BodyAgro.vue?vue&type=script&lang=js"
export * from "./BodyAgro.vue?vue&type=script&lang=js"

import "./BodyAgro.vue?vue&type=style&index=0&id=6b7d6ae0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b7d6ae0"]])

export default __exports__